var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-80"},[_c('div',{staticClass:"grid justify-center"},[_c('div',{staticClass:"text-primary mb-6"},[_vm._v("ご選択いただいたメニュー(施設・サービス)は、以下の理由によりご利用いただけません")]),_c('div',{staticClass:"text-primary mb-6"},[_vm._v("必須パラメータエラー。")]),_c('div',{staticClass:"text-primary"},[_vm._v("メニューNoの確認をしていただくか、再度検索してください")])])])
}]

export { render, staticRenderFns }